export const MAX_MEDIA_BYTES = 50_000_000;

const opaqueTokenPattern = /^[A-Za-z0-9_-]{43}$/;

export function parseOpaqueToken(value: string): string | null {
  return opaqueTokenPattern.test(value) ? value : null;
}

export function requireOpaqueToken(value: string): string {
  const token = parseOpaqueToken(value);
  if (token == null) throw new Error('Invalid invitation token.');
  return token;
}
